import React, {Component, Fragment} from 'react'
import {observer} from 'mobx-react'

import InlineCode from 'lib/struct/InlineCode'

import Field from '../../struct/Field'
import Hint from '../../struct/Hint'
import Select from '../../control/DependentSelect'
import Checkbox from '../../control/DependentCheckbox'
import Mono from '../../struct/Mono'
import SettingsGroup from '../../struct/SettingsGroup'

import * as GeneratedDocumentTtlMode from '../../../constant/GeneratedDocumentTtlMode'

import Icon from 'lib/struct/icon/Icon';

import styles from './ProfileDocumentSettings.less'
import ProfileWaSettings from './../wa/ProfileWaSettings'

const document_ttl_options = [{
    label: 'Автоматически, при каждом запросе',
    value: '60',
}, {
    label: 'Автоматически, но не чаще чем раз в час',
    value: '3600',
}, {
    label: 'Автоматически, но не чаще чем раз в день',
    value: '86400',
}, {
    label: 'Автоматически, но не чаще чем раз в неделю',
    value: '604800',
},]

const document_ttl_options_dev = [
    {
        label: 'Всегда DEV',
        value: '1',
    },
    ...document_ttl_options
]

@observer export default class ProfileDocumentSettings extends Component {
    render() {
        const {title} = this.props
        /** @type {ProfileSettingsContext} */
        const context = this.props.context
        const profile = context.profile

        return (
            <SettingsGroup title={title}>
                <ProfileWaSettings context={context}/>
                <Field label="Обновление файла">
                    <Select
                        options={GeneratedDocumentTtlMode.control_options}
                        value={profile._document_generated_document_ttl}
                        onChange={e => profile.changeTtlMode(e.target.value)}
                        state={context.form_state}
                    >
                        <option value={GeneratedDocumentTtlMode.NO_TTL_LIMIT}>Обновление только вручную или по CRON
                        </option>

                        {
                            (context.is_dev ? document_ttl_options_dev : document_ttl_options).map(option => (
                                <option
                                    key={option.value}
                                    value={GeneratedDocumentTtlMode.SECONDS.concat('/').concat(option.value)}
                                >
                                    {option.label}
                                </option>
                            ))
                        }
                    </Select>

                    <Hint>
                        <b style={{color: 'black'}}>Рекомендуем использовать обновление по Cron</b><br/>
                        Включите автоматический экспорт товаров, и YML-файл будет обновляться каждый раз при запросе его
                        URL, если возраст файла больше выбранного значения.<br/>
                        Если автоматическое обновление не выбрано, то по адресу файла будет доступна его последняя
                        версия.
                    </Hint>
                </Field>

                {
                    profile.document_generated_document_ttl_mode === GeneratedDocumentTtlMode.NO_TTL_LIMIT ? (
                        <Field>
                            {
                                context.shell_user ? (
                                    <span>Для автоматического обновления YML-файла нужно добавить команду в crontab пользователя <span
                                        className={styles['cron-option__user']}>{context.shell_user}</span></span>
                                ) : (
                                    <span>Для автоматического обновления YML-файла нужно добавить команду в crontab:</span>
                                )
                            }
                            <div className={styles['cron-option__command']}>
                                <Mono>
                                    <InlineCode>{context.getGenerateProfileManualCliCommand()}</InlineCode>
                                </Mono>
                            </div>
                        </Field>
                    ) : (null)
                }

                {
                    false ? (
                        <Fragment>
                            <Field label="Обновление при запросе">
                                <Checkbox
                                    checked={profile.document_allow_generate_on_request}
                                    onChange={e => profile.document_allow_generate_on_request = e.target.checked}
                                    state={context.form_state}
                                >
                                    Обновлять YML-файл автоматически при запросе
                                </Checkbox>

                                <Hint>
                                    Если настройка <b>выключена</b>, то при запросе URL файл не будет обновлен.<br/>
                                    <Icon name="exclamation"/> Отключите эту настройку, если обновление
                                    занимает слишком много времени и Яндекс.Маркет не может получить YML-файл.
                                </Hint>
                            </Field>

                            <Field label="Обновление по расписанию">
                                <Checkbox
                                    checked={profile.document_generate_by_cron}
                                    onChange={e => profile.document_generate_by_cron = e.target.checked}
                                    state={context.form_state}
                                >
                                    Генерировать файл по CRON
                                </Checkbox>

                                <Hint>
                                    {
                                        context.shell_user ? (
                                            <span>Для автоматического обновления YML-файлов нужно добавить команду в crontab пользователя <span
                                                className={styles['cron-option__user']}>{context.shell_user}</span></span>
                                        ) : (
                                            <span>Для автоматического обновления YML-файлов нужно добавить команду в crontab:</span>
                                        )
                                    }
                                    <div className={styles['cron-option__command']}>
                                        <Mono>
                                            <InlineCode>{context.getGenerateProfileByScheduleCliCommand()}</InlineCode>
                                        </Mono>
                                    </div>
                                    <Icon name="exclamation"/> Рекомендуемая частота запуска - раз в
                                    минуту<br/>
                                    <Icon name="exclamation"/> Не нужно добавлять команду в CRON для каждого
                                    профиля
                                </Hint>
                            </Field>
                        </Fragment>
                    ) : (null)
                }
            </SettingsGroup>
        )
    }
}